import { render, staticRenderFns } from "./TransactionBank.vue?vue&type=template&id=4338568e"
import script from "./TransactionBank.vue?vue&type=script&lang=js"
export * from "./TransactionBank.vue?vue&type=script&lang=js"
import style0 from "./TransactionBank.vue?vue&type=style&index=0&id=4338568e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports